import { io } from "socket.io-client";

const socket = io("https://rmt.cloudstakes.com/api/", {
  autoConnect: false, // Prevents auto connection before login
});

export default socket;
//
